import { TypedKeys } from '@percept/types'

export const produceKeyedMapping = <T extends object>(
  items: T[] | null | undefined,
  key: TypedKeys<T, string | number> | ((item: T) => string | number)
): Record<string | number, T> => {
  if( !items ){
    return {}
  }
  return items.reduce( (acc, item) => {
    const itemKey = typeof key === 'function' ? key(item) : item[key]
    acc[itemKey as string] = item
    return acc
  }, {} as Record<string, T>)
}

export const collateMapping = <T extends object>(
  items: T[] | null | undefined,
  key: TypedKeys<T, string | number> | ((item: T) => string | number)
): Record<string | number, T[]> => {
  if( !items ){
    return {}
  }
  return items.reduce( (acc, item) => {
    const itemKey = typeof key === 'function' ? key(item) : item[key]
    acc[itemKey as string] = acc[itemKey as string] || []
    acc[itemKey as string].push(item)
    return acc
  }, {} as Record<string, T[]>)
}

export const filterTruthyMapping = <T extends object>(obj: T): Partial<T> => {
  return Object.entries(obj).reduce( (acc, [k, v]) => {
    if( v ){
      acc[k as keyof T] = v
    }
    return acc
  }, {} as Partial<T>)
}
